import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  setQueryString(state, action: PayloadAction<any>) {
    state.queryString = action.payload;
  },
};
